import React from 'react';
import List, { defaultFilters } from '../../cruds/List';
import View from '../../cruds/View';
import Edit from '../../cruds/Edit';
import { stringNotBlank, warnStringNotBlank, notNull } from '../../cruds/validators';
import Table, { Column } from '../../components/container/Table';
import { EditButton, ViewButton, DeleteButton } from '../../components/output/CrudButton';
import OutputValue from '../../components/output/OutputValue';
import OutputText, { OutputBoolean } from '../../components/output/OutputText';
import InputText from '../../components/input/InputText';
import MainContainer from '../../components/MainContainer';
import { Switch, Route } from 'react-router-dom';
import WithRole, { withRoles } from '../../components/container/WithRole';
import RadioButtonGroup, { RadioButton } from '../../components/input/RadioButtonGroup';

const ENTITY_NAME = 'agents';
const TITLE = 'agents.title';

const CrudEdit = props => {
  const validators = [
    stringNotBlank('description', 'agents.err.description'),
    warnStringNotBlank('casRn', 'agents.warn.cas'),
    notNull('mixture', 'agents.err.mixture'),
  ];
  return (
    <Edit {...props}
        title={TITLE}
        entityName={ENTITY_NAME}
        entityRoute={ENTITY_NAME}
        entityId={props.match.params.number}
        validators={validators}
        initialValue={{ mixture: false }}
    >
      <InputText name="description" label="agents.description" required />
      <InputText name="casRn" label="agents.casRn" />
      <RadioButtonGroup name="mixture" label="agents.mixture" required>
        <RadioButton value="true" label="substances.true" />
        <RadioButton value="false" label="substances.false" />
      </RadioButtonGroup>
    </Edit>
  );
};

const CrudView = props => (
  <View title={TITLE} entityName={ENTITY_NAME} entityRoute={ENTITY_NAME} entityId={props.match.params.number}>
    <OutputText name="description" label="agents.description" />
    <OutputText name="casRn" label="agents.casRn" />
    <OutputBoolean name="mixture" label="agents.mixture" />
  </View>
);

const CrudList = props => {
  const table = <Table>
                  <Column label="agents.description" orderingName="DESCRIPTION">
                    <OutputValue name="description" />
                  </Column>
                  <Column label="agents.casRn" orderingName="CAS_RN">
                    <OutputValue name="casRn" />
                  </Column>
                  <Column label="agents.mixture">
                    <OutputBoolean name="mixture" />
                  </Column>
                  <Column>
                    <WithRole roles={['A', 'B', 'C']}>
                      <EditButton entityRoute={props.match.url} />
                    </WithRole>
                    <ViewButton entityRoute={props.match.url} />
                    <WithRole roles={['A', 'B', 'C']}>
                      <DeleteButton />
                    </WithRole>
                  </Column>
                </Table>;

  return (
    <List title={TITLE}
          entityName={ENTITY_NAME}
          entityRoute={ENTITY_NAME}
          component={table}
          filters={defaultFilters()}
          defaultOrdering="DESCRIPTION"
          hideAddButton = {!withRoles(['A', 'B', 'C'])}
    />
  );
};

const Agents = props => {
  const basePath = props.match.url;
  return (
    <MainContainer>
      <Switch>
        <Route exact path={basePath} component={CrudList} />
        <Route exact path={basePath + '/view/:number'} component={CrudView} />
        <Route exact path={basePath + '/edit/:number'} render={props => <CrudEdit {...props} />} />
        <Route exact path={basePath + '/add'} render={props => <CrudEdit {...props} />} />
      </Switch>
    </MainContainer>
  );
};

export default Agents;



// WEBPACK FOOTER //
// ./src/main/pages/registry/Agents.js